<template>
  <div v-if="activeView !== ''" class="mb-4 flex items-center text-sm">
    <router-link
      to="/administration"
      class="text-blue-600 hover:text-blue-800"
    >
      Administration
    </router-link>
    <span v-if="activeView === 'email-templates'" class="mx-2 text-gray-500">/</span>
    <router-link
      v-if="activeView === 'email-templates'"
      to="/administration/email-templates"
      class="text-gray-700 hover:text-blue-800"
    >
      Email Template Management
    </router-link>
    <span v-if="activeView === 'user-roles'" class="mx-2 text-gray-500">/</span>
    <router-link
      v-if="activeView === 'user-roles'"
      to="/administration/user-roles"
      class="text-gray-700 hover:text-blue-800"
    >
      User Role Management
    </router-link>
    <span v-if="activeView === 'system-config'" class="mx-2 text-gray-500">/</span>
    <router-link
      v-if="activeView === 'system-config'"
      to="/administration/system-config"
      class="text-gray-700 hover:text-blue-800"
    >
      System Configuration
    </router-link>
    <span v-if="activeView === 'audit-logs'" class="mx-2 text-gray-500">/</span>
    <router-link
      v-if="activeView === 'audit-logs'"
      to="/administration/audit-logs"
      class="text-gray-700 hover:text-blue-800"
    >
      Audit Logs
    </router-link>
    <span v-if="activeView === 'manage-knowledgebase'" class="mx-2 text-gray-500">/</span>
    <router-link
      v-if="activeView === 'manage-knowledgebase'"
      to="/administration/manage-knowledgebase"
      class="text-gray-700 hover:text-blue-800"
    >
      Knowledgebase Advisori
    </router-link>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'BreadcrumbNavigation',
  props: {
    activeView: {
      type: String,
      required: true
    }
  },
  emits: ['navigate']
});
</script>
